import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Resume() {
    useEffect(() => {
        // Initialize AOS only
        AOS.init({
            duration: 600,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        });
    }, []);

    return (
        <div className="resume-page">
            <main className="main">
                <section id="resume" className="resume section">
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Resume</h2>
                        <p>
                            Innovative and results-driven Full Stack Developer with 2 years of experience in JHipster, React, and Spring Boot. 
                            Cybersecurity expert with proven track record in building secure, scalable web applications and providing comprehensive IT solutions.
                        </p>
                    </div>

                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row">
                            <div className="col-lg-6">
                                {/* Education Section - unchanged */}
                                <div className="resume-item" data-aos="fade-up">
                                    <h3 className="resume-title">Education</h3>

                                    <div className="resume-content">
                                        <article className="education-item">
                                            <h4>Bachelor of Cyber Security (BCSe)</h4>
                                            <h5>2022 - 2025</h5>
                                            <p className="institution">
                                                <em>Institute of Accountancy Arusha (IAA)</em>
                                            </p>
                                            <p>
                                                Comprehensive education in cybersecurity principles, network security, vulnerability assessment, 
                                                and digital forensics. Focus on secure software development and information protection.
                                            </p>
                                        </article>

                                        <article className="education-item">
                                            <h4>Advanced Certificate of Secondary Education (ACSEE)</h4>
                                            <h5>2020 - 2022</h5>
                                            <p className="institution">
                                                <em>Kibaha Secondary School, Kibaha</em>
                                            </p>
                                            <p>
                                                Advanced level education with focus on sciences and mathematics, providing strong foundation 
                                                for technical and computing studies.
                                            </p>
                                        </article>

                                        <article className="education-item">
                                            <h4>Certificate of Secondary Education (CSEE)</h4>
                                            <h5>2015 - 2019</h5>
                                            <p className="institution">
                                                <em>Musabe Secondary School, Mwanza</em>
                                            </p>
                                            <p>
                                                Ordinary level education with excellent performance in mathematics and sciences, 
                                                establishing academic foundation for higher education.
                                            </p>
                                        </article>
                                    </div>
                                </div>

                                {/* Technical Skills Section - updated with new skills */}
                                <div className="resume-item" data-aos="fade-up">
                                    <h3 className="resume-title">Technical Skills</h3>
                                    <div className="resume-content">
                                        <div className="skill-item">
                                            <h4>Full Stack Development</h4>
                                            <p>JHipster, React, Spring Boot, REST APIs, microservices</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>Cybersecurity</h4>
                                            <p>Vulnerability assessment, penetration testing, security implementation</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>Database Management</h4>
                                            <p>MySQL design, optimization, data modeling</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>Python & Automation</h4>
                                            <p>Scripting, automation, data processing</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>Social Media Management</h4>
                                            <p>Content creation, audience growth, platform analytics, monetization strategies</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>Motion Graphics & Video Editing</h4>
                                            <p>2D/3D animation, video production, motion design for educational content</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                {/* Professional Experience Section - with new entries */}
                                <div className="resume-item" data-aos="fade-up" data-aos-delay="100">
                                    <h3 className="resume-title">Professional Experience</h3>
                                    <div className="resume-content">
                                        {/* Newest role: Ekima Interactive */}
                                        <article className="experience-item">
                                            <h4>Educational Software Developer & Educational Video Content Developer </h4>
                                            <h5>Jan 2026 – Present(Part time project.)</h5>
                                            <p className="company">
                                                <em>Ekima Interactive  (Arusha Tanzania)</em>
                                            </p>
                                            <ul>
                                                <li>Develop engaging educational content using 2D/3D animations, video production, and interactive tools to make teaching and learning easy on the Ekima platform.</li>
                                                <li>Create simple student games, puzzles, and drag‑and‑drop brainstorming activities to enhance cognitive engagement.</li>
                                                <li>Collaborate with educators to align digital content with curriculum standards and improve learning outcomes.</li>
                                                <li>Produced high-quality multimedia content by combining visual storytelling, motion graphics, and audio editing techniques.</li>
                                                <li>Continuously improved content through testing, feedback collection, and iteration, ensuring relevance, usability, and educational impact</li>
                                                <li>Enhanced user experience on the Ekima platform by creating student-centered, easy-to-use digital learning experiences across web and mobile devices.</li>
                                            </ul>
                                        </article>

                                        {/* Data Village */}
                                        <article className="experience-item">
                                            <h4>IT Support & Network Security Specialist</h4>
                                            <h5>2023 – 2025</h5>
                                            <p className="company">
                                                <em>Data Village (Arusha Tanzania)</em>
                                            </p>
                                            <ul>
                                                <li>Provided customer support by calling and visiting clients to troubleshoot technical problems related to networks, CCTV, and communication systems.</li>
                                                <li>Installed and configured CCTV camera systems (IP‑based), including camera mounting, running network cables, setting up NVRs, assigning IP addresses, and enabling remote viewing.</li>
                                                <li>Installed and configured IP phones by setting up SIP accounts, configuring extensions, and ensuring proper connectivity through the local network.</li>
                                                <li>Set up and maintained access control systems, including configuring user permissions, registering access cards/fingerprints, and connecting systems to the network for monitoring.</li>
                                                <li>Designed and configured secure Local Area Networks (LANs) by setting up routers and switches, assigning IP addresses, configuring VLANs where necessary, and ensuring stable connectivity.</li>
                                                <li>Installed and managed firewalls using pfSense, including setting firewall rules, configuring NAT, managing bandwidth, blocking unwanted traffic, and improving overall network security.</li>
                                                <li>Applied network security measures such as disabling unused ports, changing default credentials, segmenting networks, and monitoring traffic to maintain privacy and prevent unauthorized access.</li>
                                                <li>Visited client sites to install, test, and troubleshoot systems, ensuring all equipment was fully functional before handover.</li>
                                            </ul>
                                        </article>

                                        {/* Existing Lion Track Safari */}
                                        <article className="experience-item">
                                            <h4>Information Technology (IT) & Social Media Officer</h4>
                                            <h5>July 2024 – Feb 2025</h5>
                                            <p className="company">
                                                <em>Lion Track Safari Company, Arusha</em>
                                            </p>
                                            <ul>
                                                <li>Developed and maintained the Liontrack Safari website and internal systems, creating functional, user‑friendly, and secure digital solutions.</li>
                                                <li>Managed the company’s IT systems and provided technical support to ensure smooth daily operations.</li>
                                                <li>Responsible for maintaining computers, internet connectivity, and basic network infrastructure.</li>
                                                <li>Led social media management by creating and publishing engaging content, responding to customer inquiries, and promoting safari packages across digital platforms.</li>
                                                <li>Delivered cybersecurity awareness training to staff members, improving phishing detection and reducing security incidents that may harm the Company.</li>
                                                <li>Supported online branding, customer communication, and digital marketing efforts to improve visibility and client engagement.</li>
                                            </ul>
                                        </article>

                                        {/* Existing Tiketika */}
                                        <article className="experience-item">
                                            <h4>Full Stack Developer</h4>
                                            <h5>July 2024 – June 2025</h5>
                                            <p className="company">
                                                <em>Tiketika Tanzania, Dar es Salaam</em>
                                            </p>
                                            <ul>
                                                <li>Contributed to the development of a smart digital ticketing system aimed at improving events ticketing in Dar es Salaam.</li>
                                                <li>Worked on both the frontend (Flutter) and backend integration to enhance user experience and performance. This was a ticket scanning app.</li>
                                            </ul>
                                        </article>
                                    </div>
                                </div>

                                {/* Languages Section */}
                                <div className="resume-item" data-aos="fade-up" data-aos-delay="200">
                                    <h3 className="resume-title">Languages</h3>
                                    <div className="resume-content">
                                        <div className="skill-item">
                                            <h4>Kiswahili</h4>
                                            <p>Native fluency</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>English</h4>
                                            <p>Professional working proficiency</p>
                                        </div>
                                        <div className="skill-item">
                                            <h4>French</h4>
                                            <p>Basic conversational</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}